const KeysConfigDevice = {
    lastId: '0',
    id: '0',
    cabinet_id: '1',
    ipadd_device: '2',
    portno_device: '3',
    serial_no: '4',
    active_yn: '5',
    note: '6',
    create_time: '7',
    create_userid: '8',
    del_yn: '9',
    cabinet_nm: '10',
    cabinet_cd: '11',
    delta_time: '12',
    password: '13',
    account: '14',
    factory_id: '15',
    status_key_sync_hikvision: '16',
    status_sync_hikvision: '17',
    is_online: '18',
};

const KeysPermissions = {
    id: 'o_1',
    work_status: 'o_2',
    icons: 'o_3',
    screens_key: 'o_4',
    navigate: 'o_5',
    icons_mobile: 'o_6',
    navigate_mobile: 'o_7',
    search: 'o_8',
    insert: 'o_9',
    update: 'o_10',
    delete: 'o_11',
    block: 'o_12',
    import: 'o_13',
    export: 'o_14',
};

export { KeysConfigDevice, KeysPermissions };
